<template>
  <div class="recyclingInfo">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="content">
      <div class="contentHead">
        <div class="headMark"></div>
        <div class="headText">号商详情</div>
      </div>
      <a target="_blank" :href="info.link" class="list" v-html="info.cdata">
      </a>
    </div>
  </div>
</template>
<script>
import {apiRecyclingInfo} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";

export default {
  name: 'recyclingInfo',
  props: {
  },
  components: {
    breadcrumb
  },
  data () {
    return {
      info:'',
      breadcrumbList: [
        {name: '账号交易'},
        {link: '/accRecycle', name: '账号回收'},
        {name: '号商详情'}
      ]
    }
  },
  methods: {
    getRecyclingInfo(){
      apiRecyclingInfo({
        id:this.$route.query.id
      }).then(res=>{
        this.info = res.data
      })
    }
  },
  mounted(){
    this.getRecyclingInfo()
  },
  watch: {
  },
  computed: {

  }
}
</script>

<style lang='less' scoped>
.recyclingInfo{
  width: 1200px;
  margin: 0 auto;

  .content {
    width: 100%;
    min-height: 360px;
    padding: 30px 32px 40px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    box-sizing: border-box;
  }

  .contentHead {
    display: flex;
    align-items: center;
    height: 32px;
    margin: 0 0 24px;
    padding: 0 0 18px;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);

    .headMark {
      width: 4px;
      height: 18px;
      margin: 0 10px 0 0;
      border-radius: 2px;
      background: var(--primary, #FF5A1F);
    }

    .headText {
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 28px;
    }
  }

  .list {
    display: block;
    min-height: 280px;
    padding: 6px 0 0;
    color: var(--text-main, #111827);
    line-height: 1.7;
    text-decoration: none;
  }
}
</style>

<style  scoped>
.list >>> p{
  margin: 0;
}
.list >>> img{
  display: block;
  max-width: 100%;
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}
.list >>> *{
  box-sizing: border-box;
}
</style>
